var _path, _path2, _g, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToCollapseBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5496 14.1942C23.7387 14.005 23.7387 13.6899 23.5496 13.5009L18.838 8.78929C18.7592 8.7105 18.6331 8.6632 18.5071 8.64746L18.4599 8.64746C18.3338 8.6632 18.2235 8.7105 18.1448 8.78929L13.4332 13.5009C13.2441 13.69 13.2441 14.0051 13.4332 14.1942C13.6223 14.399 13.9374 14.399 14.1423 14.1942L18.4914 9.84511L22.8404 14.1942C23.0296 14.399 23.3604 14.399 23.5496 14.1942Z",
    fill: "url(#paint0_linear_2247_2367)",
    stroke: "url(#paint1_linear_2247_2367)",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5496 21.1942C23.7387 21.005 23.7387 20.6899 23.5496 20.5009L18.838 15.7893C18.7592 15.7105 18.6331 15.6632 18.5071 15.6475L18.4599 15.6475C18.3338 15.6632 18.2235 15.7105 18.1448 15.7893L13.4332 20.5009C13.2441 20.69 13.2441 21.0051 13.4332 21.1942C13.6223 21.399 13.9374 21.399 14.1423 21.1942L18.4914 16.8451L22.8404 21.1942C23.0296 21.399 23.3604 21.399 23.5496 21.1942Z",
    fill: "url(#paint2_linear_2247_2367)",
    stroke: "url(#paint3_linear_2247_2367)",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2247_2367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 30C25.732 30 32 23.732 32 16C32 8.26801 25.732 2 18 2C10.268 2 4 8.26801 4 16C4 23.732 10.268 30 18 30Z",
    fill: "#FF6C37"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6611 14.1942C22.8356 14.005 22.8356 13.6899 22.6611 13.5009L18.3119 8.78929C18.2392 8.7105 18.1228 8.6632 18.0065 8.64746L17.9629 8.64746C17.8465 8.6632 17.7447 8.7105 17.672 8.78929L13.3229 13.5009C13.1483 13.69 13.1483 14.0051 13.3229 14.1942C13.4974 14.399 13.7883 14.399 13.9774 14.1942L17.992 9.84511L22.0065 14.1942C22.1811 14.399 22.4865 14.399 22.6611 14.1942Z",
    fill: "url(#paint4_linear_2247_2367)",
    stroke: "url(#paint5_linear_2247_2367)",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.946 21.1942C23.1206 21.005 23.1206 20.6899 22.946 20.5009L18.5968 15.7893C18.5241 15.7105 18.4077 15.6632 18.2914 15.6475L18.2478 15.6475C18.1314 15.6632 18.0296 15.7105 17.9569 15.7893L13.6078 20.5009C13.4332 20.69 13.4332 21.0051 13.6078 21.1942C13.7824 21.399 14.0732 21.399 14.2624 21.1942L18.2769 16.8451L22.2914 21.1942C22.466 21.399 22.7714 21.399 22.946 21.1942Z",
    fill: "url(#paint6_linear_2247_2367)",
    stroke: "url(#paint7_linear_2247_2367)",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2247_2367",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2247_2367"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2247_2367",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2247_2367",
    x1: 19.0005,
    y1: 13.4995,
    x2: 19.0005,
    y2: 7.49951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2247_2367",
    x1: 23.6914,
    y1: 11.4976,
    x2: 13.2913,
    y2: 11.4976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2247_2367",
    x1: 19.0005,
    y1: 20.4995,
    x2: 19.0005,
    y2: 14.4995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2247_2367",
    x1: 23.6914,
    y1: 18.4976,
    x2: 13.2913,
    y2: 18.4976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2247_2367",
    x1: 18.4619,
    y1: 13.4995,
    x2: 18.4619,
    y2: 7.49951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2247_2367",
    x1: 22.792,
    y1: 11.4976,
    x2: 13.1919,
    y2: 11.4976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2247_2367",
    x1: 18.7468,
    y1: 20.4995,
    x2: 18.7468,
    y2: 14.4995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2247_2367",
    x1: 23.0769,
    y1: 18.4976,
    x2: 13.4768,
    y2: 18.4976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToCollapseBackground);
export default __webpack_public_path__ + "static/media/ToCollapseBackground.e0502576cc1c86c8c08bbf940e0ffc74.svg";
export { ForwardRef as ReactComponent };